<template>
  <div
    v-if="hasErrorMessage"
    class="visitor-error-message"
    :class="{
      bold: bold,
      center: center,
      small: small,
      large: large,
      whitespace: whitespace,
      [textClasses]: true
    }"
    role="alert"
    aria-live="assertive"
  >
    <i class="ri ri-alert-line visitor-error-icon"></i>
    <span>{{ errorMessage }}</span>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from "vue"
export default {
  name: "VisitorErrorHandler",
  props: {
    error: {
      type: Object,
      default: null
    },
    keepAlive: {
      type: Boolean,
      default: false
    },
    keepShort: {
      type: Boolean,
      default: false
    },
    textClasses: {
      type: String,
      default: ""
    },
    bold: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    whitespace: {
      type: Boolean,
      default: false
    }
  },
  emits: ["done"],
  setup(props, { emit }) {
    const timeoutId = ref(null)
    const formatErrorMessage = (error) => {
      if (!error) {
        return ""
      }

      const errorData = error?.response?.data || error?.data || error

      if (errorData?.errors && typeof errorData.errors === "object") {
        const errorMessages = []
        Object.values(errorData.errors).forEach((messages) => {
          if (Array.isArray(messages)) {
            errorMessages.push(...messages)
          } else if (typeof messages === "string") {
            errorMessages.push(messages)
          }
        })

        if (errorMessages.length > 0) {
          return errorMessages.join(" ")
        }
      }

      return (
        errorData?.message ||
        error?.response?.data?.message ||
        error?.message ||
        ""
      )
    }

    const errorMessage = computed(() => {
      return formatErrorMessage(props?.error)
    })
    const hasErrorMessage = computed(() => {
      return errorMessage?.value?.trim()?.length > 0 || false
    })

    onMounted(() => {
      const time = props.keepShort ? 3000 : props.keepAlive ? 30000 : 10000
      timeoutId.value = setTimeout(() => {
        emit("done")
      }, time)
    })

    onUnmounted(() => {
      if (timeoutId.value) clearTimeout(timeoutId.value)
    })

    return {
      hasErrorMessage,
      errorMessage
    }
  }
}
</script>

<style scoped></style>
